import { css, SerializedStyles } from '@emotion/core'

import { BorderRadius } from '../../../enums/borderRadius'
import { Color } from '../../../enums/color'
import { StyledComponent } from '../../../types/styledComponent'

export const getHoverStyle = (
  Control: StyledComponent,
  ControlWrapper: StyledComponent,
  checked: boolean,
  indeterminate: boolean,
): SerializedStyles => css`
  &:hover {
    ${Control} {
      ${checked
        ? css`
            color: ${Color.White};
            background-color: ${Color.Lavender600};
          `
        : css`
            border-color: ${Color.Grey500};
            background-color: ${Color.White};
          `};
    }

    ${(!checked || indeterminate) &&
    css`
      ${ControlWrapper} {
        border-radius: ${BorderRadius.RFull};
        box-shadow: 0 0 0 8px ${Color.Grey50};
      }
    `}
  }
`
